import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-star\"><path d=\"M19.9 6.2c1.3.1 2.2 1.3 2.1 2.6-.1.6-.3 1.1-.8 1.5l-3.5 3.2 1 4.6c.3 1.3-.6 2.5-1.8 2.8-.6.1-1.1 0-1.6-.3L11 18.3l-4.2 2.3c-1.1.6-2.6.2-3.2-.9-.3-.5-.4-1.1-.3-1.6l1-4.6-3.5-3.2c-1-.9-1-2.4-.2-3.3.4-.4.9-.7 1.5-.8l4.8-.5 2-4.3C9.4.2 10.9-.3 12 .2c.5.2.9.7 1.2 1.2l2 4.3 4.7.5zm-8.3-3.9c0-.2-.2-.3-.3-.3-.3-.2-.7 0-.9.3L8.2 7c-.1.2-.3.4-.5.4L2.5 8c-.1 0-.3.1-.4.2-.3.3-.2.7 0 1L6 12.6c.2.2.3.4.2.6l-1 5c0 .2 0 .3.1.5.2.3.6.4.9.3l4.5-2.5c.2-.1.5-.1.7 0l4.5 2.5c.1.1.3.1.5.1.4-.1.6-.4.5-.8l-1-5c0-.2 0-.5.2-.6l3.8-3.5c.1-.2.2-.3.2-.5 0-.4-.2-.7-.6-.7l-5.2-.6c-.2 0-.4-.2-.5-.4l-2.2-4.7z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-star.svg
// module id = 890
// module chunks = 74